import { API } from './resources'

export default {
  getQuestionVisibility: (userID, userType) => {
    return API.get('/user/customQuestions/visibility', { params: { userID, userType } })
  }
}
